import React from 'react';

import { useIntl } from 'react-intl';
import { di } from 'react-magnetic-di';

import { Text } from '@atlaskit/primitives/compiled';

import { asFormDateTimeField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { parseDateTimeValueForView } from '../../../../../../../../common/utils';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const ViewDateTimeInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formDateTimeField = asFormDateTimeField(formField);
	const intl = useIntl();

	if (formDateTimeField === undefined) {
		return <></>;
	}

	const { formattedDateValue, formattedTimeValue } = parseDateTimeValueForView(
		formDateTimeField.value?.date || '',
		formDateTimeField.value?.localTime || '',
		intl.locale,
	);

	return (
		<Text testId={`field-input-date-time-view-${fieldId}`}>
			{formattedDateValue && !formattedTimeValue && <>{formattedDateValue}</>}
			{!formattedDateValue && formattedTimeValue && <>{formattedTimeValue}</>}
			{formattedDateValue &&
				formattedTimeValue && (
					// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
					<>{`${formattedDateValue}, ${formattedTimeValue}`}</>
				)}
		</Text>
	);
};
